var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminatePaperBook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67651 8.94092L16.6601 8.31289C18.7789 8.20184 20.855 8.93705 22.4318 10.3568C24.0086 11.7765 24.9567 13.7644 25.0678 15.8832L26.5332 43.8449C26.4499 42.2557 25.7388 40.7648 24.5562 39.7C23.3736 38.6352 21.8165 38.0838 20.2274 38.1671L6.24659 38.8998L4.67651 8.94092Z",
    stroke: "#3571D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6216 6.84732L32.6381 7.47536C30.5193 7.5864 28.5313 8.53459 27.1116 10.1113C25.6919 11.6881 24.9567 13.7643 25.0677 15.8831L26.5331 43.8447C26.4499 42.2556 27.0013 40.6985 28.066 39.5159C29.1308 38.3333 30.6218 37.6222 32.2109 37.5389L46.1917 36.8062L44.6216 6.84732Z",
    stroke: "#3571D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminatePaperBook);
export default __webpack_public_path__ + "static/media/eliminate-paper-book.da2db8080974f865b27bdf5a2b254a23.svg";
export { ForwardRef as ReactComponent };